import React from 'react'

import { parsePhone } from 'services/Utilities'
import { t } from 'translations'

const UserPhones = ({ phones }) => (
  <div className="d-flex flex-column">
    {phones.map(({ phoneNumber, type }, index) => (
      <div className="text-nowrap" key={index}>
        <div>{parsePhone(phoneNumber)}</div>
        <small className="text-muted d-block">{t(type)}</small>
      </div>
    ))}
  </div>
)

export default UserPhones
